import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useReviewCreationV1Data, setReviewCreationKey } from 'reducers/reviewCreationV1Slice';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ReviewCreationSidepanel } from '../components/ReviewCreationSidepanel';
import { GoalsMissingValidation } from '../sections/validationComps/GoalsMissingValidation';
// import { GradeMissingValidation } from '../sections/validationComps/GradeMissingValidation';
import { ManagerMissingValidation } from '../sections/validationComps/ManagerMissingValidation';

const ValidationPanel = () => {
  const dispatch = useDispatch();

  const { isValidationPanelOpen } = useReviewCreationV1Data();

  const handleClose = () => {
    dispatch(setReviewCreationKey({ isValidationPanelOpen: false }));
  };

  return (
    <ReviewCreationSidepanel isOpen={isValidationPanelOpen} onClose={handleClose} showFooterCloseButton>
      <Flex flexDir="column" py={2} gap={2}>
        <Flex p="8px 12px 4px 2px" flexDir="column" gap={2}>
          <TextBodyMedium bold>Validation</TextBodyMedium>
        </Flex>

        <GoalsMissingValidation />
        <ManagerMissingValidation />
        {/* keeping for now as not sure if this might be required too. If you are reading this after march 2025, remove this and related file*/}
        {/* <GradeMissingValidation /> */}
      </Flex>
    </ReviewCreationSidepanel>
  );
};

export { ValidationPanel };
